























































import { Vue, Component, Prop } from 'vue-property-decorator';
import draggable from 'vuedraggable';
import { ISortData } from '@/interface/GamesManagement';

@Component({
  components: {
    draggable,
  },
})
export default class GamesManagementBody extends Vue {
  @Prop() readonly data!: Array<ISortData>;

  @Prop() readonly isEditSort!: boolean;

  @Prop() readonly sortData!: Function

  private sortTimer: ReturnType<typeof setTimeout> | null = null;

  newSortData() {
    this.sortData(this.data);
  }

  getNetWin(item: ISortData): number {
    return item.riskConfig && item.riskConfig.netWin ? item.riskConfig.netWin : 0;
  }

  getMultiplier(item: ISortData): number {
    return item.riskConfig && item.riskConfig.multiplier ? item.riskConfig.multiplier : 0;
  }

  getSort(item: ISortData): number {
    return item.sortweb
      ? item.sortweb
      : item._sort
        ? item._sort
        : item.sort
          ? item.sort
          : 0;
  }

  updateNetWin(index: number, value: string) {
    const numericValue = parseFloat(value) || 0;
    if (!this.data[index].riskConfig) {
      this.data[index].riskConfig = { netWin: 0, multiplier: 0 };
    }
    this.data[index].riskConfig.netWin = numericValue;
    this.sortData(this.data);
  }

  updateMultiplier(index: number, value: string) {
    const numericValue = parseFloat(value) || 0;
    if (!this.data[index].riskConfig) {
      this.data[index].riskConfig = { netWin: 0, multiplier: 0 };
    }
    this.data[index].riskConfig.multiplier = numericValue;
    this.sortData(this.data);
  }

  updateSort(index: number, value: string) {
    if (this.sortTimer) {
      clearTimeout(this.sortTimer);
    }

    this.sortTimer = setTimeout(() => {
      this.sortTimer = null;

      const total = this.data.length;
      const parsed = parseInt(value, 10);
      if (Number.isNaN(parsed)) {
        this.sortData(this.data);
        return;
      }

      const target = Math.max(1, Math.min(total, parsed));
      const targetIndex = target - 1;
      if (targetIndex === index) {
        this.sortData(this.data);
        return;
      }

      const [moving] = this.data.splice(index, 1);
      this.data.splice(targetIndex, 0, moving);

      this.sortData(this.data);
    }, 2000);
  }
}
